import Flickity from 'flickity'
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484
import jump from 'jump.js'
require('flickity-bg-lazyload')

export default hero => {
  const slideshow = hero.querySelector('.js-carousel')
  const loader = hero.querySelector('.js-loader')
  const textBlocks = hero.querySelectorAll('.js-carousel-desktop-text')
  const deckBlocks = hero.querySelectorAll('.js-carousel-deck')
  const ctaButtons = hero.querySelectorAll('.js-cta-btn')
  const mobileTextBlocks = hero.querySelectorAll('.js-carousel-text')
  const mobileDeckBlocks = hero.querySelectorAll('.js-carousel-mobile-deck')
  const mobileCtaButtons = hero.querySelectorAll('.js-cta-mobile-btn')
  const slides = slideshow.querySelectorAll('.js-slide')
  const jumpLink = hero.querySelector('.js-explore-jump')
  const header = document.querySelector('.js-header-main')

  if (slideshow) {
    setTimeout(() => {
      slideshow.classList.add('show')
      loader.classList.add('hide')
      slides.forEach(slide => {
        if (slide.querySelector('video')) {
          let videoElement = slide.querySelector('video')
          videoElement.getAttribute('data-video-src')
          videoElement.src = videoElement.getAttribute('data-video-src')
          videoElement.load()
        }
      })
    }, 250)

    setTimeout(() => {
      header.classList.add('move')
    }, 450)

    const flkty = new Flickity(slideshow, {
      contain: true,
      prevNextButtons: false,
      // bgLazyLoad: true,
      bgLazyLoad: 1,
      wrapAround: true,
      autoPlay: 7000
    })

    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    if (slides.length > 0) {
      mobileTextBlocks[0].classList.add('active')
      mobileDeckBlocks[0].classList.add('active')
      mobileCtaButtons[0].classList.add('active')
      textBlocks[0].classList.add('active')
      deckBlocks[0].classList.add('active')
      ctaButtons[0].classList.add('active')
      setTimeout(() => {
        mobileTextBlocks[0].classList.add('visible')
        mobileDeckBlocks[0].classList.add('visible')
        mobileCtaButtons[0].classList.add('visible')
        textBlocks[0].classList.add('visible')
        deckBlocks[0].classList.add('visible')
        ctaButtons[0].classList.add('visible')
      }, 300)
    }

    // default colors
    const defaultColor = slides[0] ? slides[0].getAttribute('data-color') : 'cw'
    const defaultNavColor = slides[0] ? slides[0].getAttribute('data-nav-color') : 'cw'
    jumpLink.classList.add(defaultColor)
    header.classList.add(defaultNavColor)

    const dots = hero.querySelector('.flickity-page-dots')
    let dotsLength = dots.children.length
    if (dotsLength === 1) {
      dots.style.display = 'none'
    }
    dots.classList.add(defaultColor)

    flkty.on('change', (index) => {
      const color = slides[index].getAttribute('data-color')
      const navColor = slides[index].getAttribute('data-nav-color')
      jumpLink.classList.remove('cw', 'cb')
      dots.classList.remove('cw', 'cb')
      header.classList.remove('cw', 'cb')
      jumpLink.classList.add(color)
      dots.classList.add(color)
      header.classList.add(navColor)

      mobileTextBlocks.forEach((mobileText, i) => {
        if (index !== i) {
          mobileText.classList.remove('visible')
          mobileText.classList.remove('active')
        }
      })
      mobileTextBlocks[index].classList.add('active')
      setTimeout(() => {
        mobileTextBlocks[index].classList.add('visible')
      }, 400)

      mobileDeckBlocks.forEach((deck, i) => {
        if (index !== i) {
          deck.classList.remove('visible')
          deck.classList.remove('active')
        }
      })
      mobileDeckBlocks[index].classList.add('active')
      setTimeout(() => {
        mobileDeckBlocks[index].classList.add('visible')
      }, 400)

      mobileCtaButtons.forEach((btn, i) => {
        if (index !== i) {
          btn.classList.remove('visible')
          btn.classList.remove('active')
        }
      })
      mobileCtaButtons[index].classList.add('active')
      setTimeout(() => {
        mobileCtaButtons[index].classList.add('visible')
      }, 400)

      textBlocks.forEach((text, i) => {
        if (index !== i) {
          text.classList.remove('visible')
          text.classList.remove('active')
        }
      })
      textBlocks[index].classList.add('active')
      setTimeout(() => {
        textBlocks[index].classList.add('visible')
      }, 400)

      deckBlocks.forEach((deck, i) => {
        if (index !== i) {
          deck.classList.remove('visible')
          deck.classList.remove('active')
        }
      })
      deckBlocks[index].classList.add('active')
      setTimeout(() => {
        deckBlocks[index].classList.add('visible')
      }, 400)

      ctaButtons.forEach((btn, i) => {
        if (index !== i) {
          btn.classList.remove('visible')
          btn.classList.remove('active')
        }
      })
      ctaButtons[index].classList.add('active')
      setTimeout(() => {
        ctaButtons[index].classList.add('visible')
      }, 400)

      setTimeout(() => {
        flkty.playPlayer()
      }, 10000)
    })

    setTimeout(() => {
      flkty.resize()
    }, 1000)
  }

  jumpLink.addEventListener('click', () => {
    jump('.js-explore-brand', {
      offset: -75
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/hero.js